var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageContainer"},[_c('index',{attrs:{"type":_vm.type},on:{"setType":_vm.settype}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }